import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  variant?: 'horizontal' | 'icon' | 'white';
  size?: 'sm' | 'md' | 'lg';
}

export function Logo({ className, variant = 'horizontal', size = 'md' }: LogoProps) {
  const sizeClasses = {
    sm: variant === 'icon' ? 'h-8' : 'h-6',
    md: variant === 'icon' ? 'h-12' : 'h-8',
    lg: variant === 'icon' ? 'h-16' : 'h-10',
  };

  const logoSrc = {
    horizontal: '/images/Kuiva logo Horizontal.png',
    icon: '/images/icone.png',
    white: '/images/Kuiva logo Horizontal white.png',
  };

  return (
    <img
      src={logoSrc[variant]}
      alt="Kuiva"
      decoding="async"
      fetchPriority={variant === 'horizontal' ? 'high' : 'auto'}
      className={cn(
        sizeClasses[size],
        'object-contain object-left w-auto max-w-full',
        variant === 'horizontal' &&
          'max-w-[min(100%,11rem)] sm:max-w-[13rem] md:max-w-[16rem] lg:max-w-none',
        className
      )}
    />
  );
}
